import { OFFLINE_WRITE, type OfflineWriteKey } from "./capabilities";

// A handler registers when its API module loads, and autoCodeSplitting leaves
// those modules in lazy route chunks. The Record type makes a new write key
// without a loader fail the typecheck. Grass and livestock load through their
// domain barrels, because importing both domains' measurements or operations
// modules whole makes fallow report their same-named hooks as duplicates.
const REPLAY_HANDLER_MODULES: Record<OfflineWriteKey, () => Promise<unknown>> =
	{
		[OFFLINE_WRITE.animalsCreate]: () => import("@/api/livestock/animals"),
		[OFFLINE_WRITE.measurementsCreate]: () => import("@/api/livestock"),
		[OFFLINE_WRITE.measurementsBatchCreate]: () =>
			import("@/api/livestock/batch"),
		[OFFLINE_WRITE.operationsCreate]: () => import("@/api/livestock"),
		[OFFLINE_WRITE.paddockMeasurementsCreate]: () => import("@/api/grass"),
		[OFFLINE_WRITE.paddockOperationsCreate]: () => import("@/api/grass"),
		[OFFLINE_WRITE.breakdownReportsCreate]: () =>
			import("@/api/equipment/breakdowns"),
		[OFFLINE_WRITE.tasksComplete]: () => import("@/api/planning/tasks"),
		[OFFLINE_WRITE.manualEntryCreate]: () =>
			import("@/api/financial/transactions"),
	};

function isOfflineWriteKey(key: string): key is OfflineWriteKey {
	return Object.hasOwn(REPLAY_HANDLER_MODULES, key);
}

export async function loadReplayHandler(key: string): Promise<void> {
	if (!isOfflineWriteKey(key)) return;
	try {
		await REPLAY_HANDLER_MODULES[key]();
	} catch (err) {
		// The item then replays as `unknown-key` and stays queued. It syncs once
		// the chunk loads, which a stale build only does after a reload.
		console.warn(
			`[offline-replay] Failed to load the handler for "${key}"`,
			err,
		);
	}
}
